import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { subscriptionService } from '../api/services';
import './SubscriptionsPage.css';

const SubscriptionsPage = () => {
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchSubs = async () => {
      try {
        const res = await subscriptionService.list();
        setSubs(res.data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchSubs();
  }, []);

  // 取消訂閱後直接從本地清單移除
  const handleUnsubscribe = async (sub) => {
    try {
      await subscriptionService.unsubscribe(sub.target_type, sub.target_id);
      setSubs((prev) => prev.filter((s) => !(s.target_type === sub.target_type && s.target_id === sub.target_id)));
    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) return <div className="container mt-5">載入中...</div>;

  const channels = subs.filter((s) => s.target_type === 'CHANNEL');
  const tags = subs.filter((s) => s.target_type === 'TAG');

  // 訂閱的頻道導向該頻道列表、標籤導向以該標籤篩選的首頁
  const targetLink = (s) => (s.target_type === 'CHANNEL' ? `/?channel=${s.target_id}` : `/?tag=${s.target_id}`);

  const renderGroup = (title, list, emptyText) => (
    <div className="sub-group">
      <h2>{title}</h2>
      {list.length === 0 ? (
        <p className="sub-empty">{emptyText}</p>
      ) : (
        <div className="sub-list">
          {list.map((s) => (
            <div key={`${s.target_type}:${s.target_id}`} className="sub-item">
              <Link to={targetLink(s)} className="sub-name">
                {s.target_icon ? `${s.target_icon} ` : ''}{s.target_name || '(已不存在)'}
              </Link>
              <button className="sub-remove" onClick={() => handleUnsubscribe(s)}>取消追蹤</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );

  return (
    <div className="subscriptions-page">
      <div className="container">
        <div className="page-header">
          <h1>我的訂閱</h1>
          <p>你追蹤的頻道與標籤，有新文章時會通知你</p>
        </div>

        {error && <div className="alert alert-danger">{error}</div>}

        {renderGroup('追蹤的頻道', channels, '還沒有追蹤任何頻道，進入頻道頁點「追蹤」即可訂閱')}
        {renderGroup('追蹤的標籤', tags, '還沒有追蹤任何標籤，在文章的標籤旁點「追蹤」即可訂閱')}
      </div>
    </div>
  );
};

export default SubscriptionsPage;
